import subscribeThemeStore from './theme';

export function subscribeStore() {
  subscribeThemeStore();
}
